import React, { FC } from 'react';

import {
  Amex,
  Visa,
  CardFill,
  DinersClubLogo,
  DiscoverLogo,
  Jcb,
} from '@crehana/icons';
import { MasterCard } from '@crehana/icons/logos';

const CardBrandIcon: FC<{ cardType: string }> = ({ cardType }) => {
  switch (cardType) {
    case 'American Express':
      return <Amex size={14} ignoreColor className="fill-current text-white" />;
    case 'Visa':
      return <Visa size={24} ignoreColor className="fill-current text-white" />;
    case 'MasterCard':
      return (
        <MasterCard size={36} ignoreColor className="fill-current text-white" />
      );
    case 'Diners Club':
      return (
        <DinersClubLogo
          size={36}
          ignoreColor
          className="fill-current text-white"
        />
      );
    case 'Discover':
      return (
        <DiscoverLogo
          size={16}
          ignoreColor
          className="fill-current text-white"
        />
      );
    case 'JCB':
      return <Jcb size={24} ignoreColor className="fill-current text-white" />;
    default:
      return (
        <CardFill size={48} ignoreColor className="fill-current text-white" />
      );
  }
};

export default CardBrandIcon;
